import React, {useState, useEffect, useRef} from 'react';
import { Carousel, Image } from 'antd';
import styled from "styled-components";
import usePortalService from '../../services/PortalService';
import ImageSelectable from './ImageSelectable';
import { CarouselRef } from 'antd/es/carousel';

const ImagesViewerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 368px;

    .ant-carousel .ant-image {
        width: 368px;
        height: 245px;
        overflow: hidden;
    }
    
    .ant-carousel .slick-slide img {
        border-radius: 8px;
        height: 100%;
        object-fit: cover;
    }
`

const Container = styled.div `
    display: flex; 
    gap: 4px;
    max-width: 368px;
    overflow: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; 
    -ms-overflow-style: none; 
    &::-webkit-scrollbar {
        display: none; 
    }
`

type ImagesViewerProps = {
    imagesIds: string[],
    type: string
}

export default function ImagesViewer({imagesIds, type} : ImagesViewerProps){
    const { getImage } = usePortalService();

    const [imagesSrc, setImagesSrc] = useState<string[]>([]);
    const [activeKey, setActiveKey] = useState('');

    const carouselRef = useRef<CarouselRef>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (imagesIds) {
            Promise.all(imagesIds.map(img => getImage(type, img)))
                   .then(imagesSrc => setImagesSrc(imagesSrc))
        }
    }, [imagesIds, type]);

    const handleCarousel = (index: number) => {
        setActiveKey(imagesIds[index]);
        if (containerRef.current) {
            const imageElem = containerRef.current.children[index] as HTMLElement;
            const scrollLeft = imageElem.offsetLeft - containerRef.current.offsetLeft;
            if (imageElem) {
                if (scrollLeft === 248 || scrollLeft === 0) {
                    containerRef.current.scrollLeft = scrollLeft;
                }
            }
        }
    }   

    if (imagesIds === undefined || imagesIds?.length === 0) return null;

    return (
        <ImagesViewerStyled>
            <Image.PreviewGroup items={imagesSrc}>
                <Carousel 
                    ref={carouselRef}
                    infinite={false}
                    arrows
                    dots={false}
                    afterChange={handleCarousel}
                >
                    {
                        imagesSrc.map((item, index) => (
                            <Image key={index} src={item} />
                        ))
                    }
                </Carousel>
            </Image.PreviewGroup>
            <Container ref={containerRef}>
                {imagesIds.map((item, index) => (
                    <ImageSelectable 
                        id={item} 
                        type={type} 
                        preview={false} 
                        onClick={() => {carouselRef.current && carouselRef.current.goTo(index)}} 
                        key={item} 
                        src={activeKey} 
                        active={activeKey}
                    />
                ))}
            </Container>
        </ImagesViewerStyled>
    )
}